import { useMutation } from "react-query";
import { addSingleFireAlarmSystem } from "../../../../actions/CarrierAgreementMgmt/Security";
import { toast } from "components/toastNotification";
import { FireAlarmSystemSaving } from "../atoms/atoms";
import { useRecoilState } from "recoil";

const useAddSingleFireAlarmSystem = () => {
    const [_, setIsSaving] = useRecoilState(FireAlarmSystemSaving);
    const { mutate, reset, isSuccess, data, error } = useMutation(addSingleFireAlarmSystem, {
        onError: () => {
            toast.fire(
                "Unexpected issue",
                "Unable to add the Fire Alarm System right now. Please try again shortly.",
                "error"
            );
            setIsSaving(false);
        }
    });

    return {
        mutate,
        isSuccess,
        data: error ? { status: 500 } : data ?? { status: 500 },
        reset
    }
};

export default useAddSingleFireAlarmSystem;
